<template>
  <v-app theme="pdsLightTheme">
    <GlobalSnackbar v-if="!isBlankLayout" />
    <BMS3Header v-if="!isBlankLayout" />
    <v-main>
      <v-banner
        class="align-center errorMessage"
        v-if="!isBlankLayout && !isOnline"
        sticky
        style="top: 48px; z-index: 1001"
      >
        <v-banner-text> OFFLINE - Don't clear your cache or you will lose data. </v-banner-text>
      </v-banner>
      <page-loading v-if="!isBlankLayout" />
      <Suspense><router-view></router-view></Suspense>
    </v-main>
  </v-app>
</template>

<script>
import BMS3Header from "@/components/header/BMS3Header.vue";
import PageLoading from "@/components/loading/PageLoading.vue";
import GlobalSnackbar from "@/components/globalSnackbar/GlobalAppSnackbar.vue";
import { defineComponent, onBeforeUnmount, onMounted, computed } from "vue";
import { useConfigStore } from "@/stores/config";
import { useConnectivityStore } from "@/stores/connectivity";
import { setupSyncInterval } from "@/util/syncInterval";
import { useUserStore } from "@/stores/userStore";
import { useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const configStore = useConfigStore();
    const connectivity = useConnectivityStore();
    const userStore = useUserStore();
    const route = useRoute();

    let isOnline = computed(() => connectivity.getOnlineServiceStatus);

    const isBlankLayout = computed(() => route.meta.blankLayout === true);

    onMounted(async () => {
      configStore.loadAppBuildInfo();
      connectivity.addListeners();
      await connectivity.getServiceStatus();
      //Set up backgroud process to auto sync inspection data.
      setupSyncInterval();
    });
    onBeforeUnmount(() => {
      connectivity.removeListeners();
    });

    return { userStore, isOnline, isBlankLayout };
  },
  components: {
    BMS3Header,
    GlobalSnackbar,
    PageLoading,
  },
});
</script>
